import React from 'react';
import { Container } from 'reactstrap';

const SimpleLayout = ({ children }) => (
  <main className="simple-layout">
    <Container fluid>{children}</Container>
  </main>
);

export default SimpleLayout;
